import { routes } from '~/shared/constants/routes';
import { type Mode } from '~/shared/store/mode';

const orderPatterns = {
    payin: routes['payin-order'],
    payout: routes['payout-order'],
} as const;

export const getOrderPath = (direction: Mode, orderId: string) => {
    return orderPatterns[direction].replace(':orderId', encodeURIComponent(orderId));
};
